module.exports = __webpack_public_path__ + "img/logout.15b82f30.svg";